const btnmodals = () => {
    // if (document.body.classList.contains('page-template-page-homepage')) {
        // Get the button that opens the modal
        let btn = document.getElementsByClassName("modal--trigger");
        // console.log('btn count ' + btn.length);

        // All page modals
        let modals = document.getElementsByClassName('modal--contact');
        // console.log('btn count ' + modals.length);

        // Get the <span> element that closes the modal
        let close = document.getElementsByClassName("modal--close");
        // console.log('btn count ' + close.length);

        let modal;

        // When the user clicks the button, open the modal
        for (let i = 0; i < btn.length; i++) {
            btn[i].onclick = function(e) {
                e.preventDefault();
                modal = document.querySelector(".modal--contact");
                modal.classList.add('modal__visible')
                // console.log('click open')
            }
        }

        // When the user clicks on <span> (x), close the modal
        for (let i = 0; i < close.length; i++) {
            close[i].onclick = function () {
                for (var index in modals) {
                    if (typeof modals[index].style !== 'undefined') modals[index].classList.remove('modal__visible')
                }
                // console.log('click x')
            }
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function (event) {
            if (event.target.classList.contains('modal--contact')) {
                for (let index in modals) {
                    if (typeof modals[index].style !== 'undefined') modals[index].classList.remove('modal__visible');
                }
            }
            // console.log('click outside modal')
        }
        
    // }
}
export default btnmodals;
